<template>
  <div class="qualityenterprise whitebox" style="height: 100vh;" v-title :data-title="title">
    <leftnav class="fl" mkcode="B" itemcode="B-HYJHK"></leftnav>
    <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
      <govheader></govheader>
      <div class="trade-detail-container">
        <div class="d_blocktitle d-floortitle pt-3" style="width: 100%;">
          <i class="title-icon title-icon3"></i>
          <h3 class="title">{{ baseInfo.title }}行业投资机会</h3>
        </div>
        <table class="evaluation-table">
          <tr>
            <th rowspan="2" class="background-fff cur-pointer" style="width: 200px;" @click="hanlderAi(1)">
              投资机会大小 > </th>
            <th>5年市场新空间</th>
            <th>当下市场需求 </th>
            <th>技术竞争力</th>
            <th>政策支持力度</th>
            <th>综合评价</th>
          </tr>
          <tr>
            <td>{{ baseInfo.fiveYears }}</td>
            <td>{{ baseInfo.marketRequirement }}</td>
            <td>{{ baseInfo.techCompete }}</td>
            <td>{{ baseInfo.policySupport }}</td>
            <td>{{ baseInfo.investChanceScore }}</td>
          </tr>
        </table>
        <div class="table-line-box"></div>

        <!-- <table class="evaluation-table" v-if="baseInfo.hasStrategyMatch">
  <tr>
    <th rowspan="2" class="cur-pointer" style="width: 200px" @click="hanlderAi(3)">战略匹配度 ></th>
    <th>行业类型</th>
    <th>战略协同性/纵向协同</th>
    <th>战略协同性/横向协同</th>
    <th>资源匹配度</th>
    <th>能力匹配度</th>
    <th>综合评价</th>
  </tr>
  <tr>
    <td>{{ baseInfo.industryType }}</td>
    <td>{{ baseInfo.verticalCooperate }}</td>
    <td>{{ baseInfo.horizontalCooperate }}</td>
    <td>{{ baseInfo.resourceMatch }}</td>
    <td>{{ baseInfo.capabilityMatch }}</td>
    <td>{{ baseInfo.strategyMatchScore }}</td>
  </tr>
</table> -->
        <table class="evaluation-table">
          <tr>
            <th rowspan="2" class="cur-pointer" style="width: 200px" @click="hanlderAi(3)">进入是否容易></th>
            <th>行业竞争格局</th>
            <th>行业盈利水平 </th>
            <th>行业进入门槛</th>
            <th>-</th>
            <th>综合评价</th>
          </tr>
          <tr>
            <td>{{ baseInfo.industryCompete }}</td>
            <td>{{ baseInfo.industryProfit }}</td>
            <td>{{ baseInfo.entryThreshold }}</td>
            <td></td>
            <td>{{ baseInfo.entryEasyScore }}</td>
          </tr>
        </table>
        <div class="table-line-box"></div>

        <table class="evaluation-table">
          <tr>
            <th rowspan="2" class="cur-pointer" style="width: 200px" @click="hanlderAi(2)">
              进入时机好坏 >
            </th>
            <th>行业发展阶段</th>
            <th>技术进步阶段</th>
            <th>资本支持力度</th>
            <th>-</th>
            <th>综合评价</th>
          </tr>
          <tr>
            <td>{{ baseInfo.developStage }}</td>
            <td>{{ baseInfo.techStage }}</td>
            <td>{{ baseInfo.capitalSupport }}</td>
            <td></td>
            <td>{{ baseInfo.investChanceScore }}</td>
          </tr>
        </table>


        <table class="miaoshu mt-3">
          <tr>
            <th class="cur-pointer" @click="hanlderAi(0, 'industryChancePoint')">行业机会点></th>
            <td>
              <div class="con" v-html="baseInfo.industryChancePoint"></div><span class="curp"
                @click="hanlderAi(0, 'industryChancePoint')">查看更多>> </span>
            </td>
          </tr>
          <tr>
            <th class="cur-pointer" @click="hanlderAi(0, 'abilityRequirement')">成功要素与能力要求 ></th>
            <td>
              <div class="con" v-html="baseInfo.abilityRequirement"></div><span class="curp display-block my-1 mx-1"
                @click="hanlderAi(0, 'abilityRequirement')">查看更多>> </span>
            </td>
          </tr>
          <tr>
            <th class="cur-pointer" @click="hanlderAi(0, 'entryStrategy')">进入策略 ></th>
            <td>
              <div class="con" v-html="baseInfo.entryStrategy"></div><span class="curp"
                @click="hanlderAi(0, 'entryStrategy')">查看更多>></span>
            </td>
          </tr>
          <tr>
            <th class="cur-pointer" @click="hanlderAi(0, 'businessMode')">商业模式 ></th>
            <td>
              <div class="con" v-html="baseInfo.businessMode"></div> <span class="curp"
                @click="hanlderAi(0, 'businessMode')">查看更多>></span>
            </td>
          </tr>
          <tr>
            <th class="cur-pointer" @click="hanlderAi(0, 'riskTip')">风险提示 ></th>
            <td>
              <div class="con" v-html="baseInfo.riskTip"></div> <span class="curp"
                @click="hanlderAi(0, 'riskTip')">查看更多>></span>
            </td>
          </tr>
        </table>
        <!-- 市场规模 -->
        <div class="whitebox company-investinfor" v-show="market.length > 0">
          <div class=" d_blocktitle d-floortitle pt-3" style="width: 100%;">
            <i class="title-icon title-icon3"></i>
            <h3 class="title">行业市场规模</h3>
          </div>
          <div class="market-box oh">
            <div v-for="(list, i) in market" :key="i" class="fl market-list mb-2">
              <h4 class="mt-1 market-title" @click="routerblank('/marketDetail?id=' + list.id + '&type=1')">
                {{ list.title }}</h4>
              <div style="width: 90%;height: 290px;margin: 0 auto;" :id="'bar_charts_' + i"></div>
            </div>
          </div>
        </div>
        <!-- 竞争格局 -->
        <div class="whitebox company-investinfor" v-show="compete.length > 0">
          <div class=" d_blocktitle d-floortitle pt-3" style="width: 100%;">
            <i class="title-icon title-icon3"></i>
            <h3 class="title">行业竞争格局</h3>
          </div>
          <div class="market-box  oh">
            <div v-for="(list, i) in compete" :key="i" class="fl market-list mb-2">
              <h4 class="mt-1 market-title" @click="routerblank('/marketDetail?id=' + list.id + '&type=2')">
                {{ list.title }}</h4>
              <div style="width: 90%;height: 290px;margin: 0 auto;" :id="'pie_charts_' + i"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  name: 'TradeDetail',
  computed: {
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
    ...mapGetters(['isCollapse']),

  },
  data() {
    return {
      title: '行业机会详情',
      baseInfo: {},
      id: this.$route.query.id,
      market: [],
      compete: [],
      mychart: null
    };
  },
  mounted() {

    this.getDetail();
  },
  methods: {
    hanlderAi(type, pageType) {
      //存储到本地存储，每次点击覆盖前面的数据
      let aistitle = '';
      let jsonData = {
        title: this.baseInfo.title + aistitle,
      };
      console.log(jsonData);
      localStorage.setItem('aiChatData', JSON.stringify(jsonData));
      if (type != 0) {
        this.routerblank('/ai-industry?id=' + this.baseInfo.id + '&type=' + type + "&industryChat=1");
      } else {
        this.routerblank('/ai-industry?id=' + this.id + "&pageType=" + pageType);

      }

    },
    getDetail() {
      var _this = this;
      this.bus.$emit('loading', true);
      var ajaxurl = this.$api.common.analyse.detail() + '?id=' + this.id;
      this.$axios.get(ajaxurl).then(function (res) {
        console.log('详情', res, ajaxurl);
        if (res.data.success) {
          // let info = res.data.list;
          _this.baseInfo = res.data.data;
          document.title = _this.baseInfo.title + '- 行业机会详情';
          _this.market = res.data.extend.market;
          _this.compete = res.data.extend.compete;
          _this.$nextTick(() => {
            _this.market.forEach((list, i) => {
              let isFlag = list.dataMap && !Array.isArray(list.dataMap) && Object.keys(list.dataMap).length > 0 && Object.keys(list.dataMap).every(key => key.trim() !== '');
              _this.drawShape('bar_charts_' + i, isFlag ? list.dataMap : list.dataList, list.legendName, list.unit, '');
            })
            _this.compete.forEach((list, i) => {
              _this.pieCharts('pie_charts_' + i, list.dataList, list.unit);
            })
          });

          _this.bus.$emit('loading', false);
        } else {

        }
      }).catch(function (error) {
        _this.bus.$emit('loading', false);
        // 请求失败处理 console.log(error);
      });
    },
    drawShape(el, data, legendName, unit, type) {
      // console.log(el, data, legendName, unit);

      let Ewidth = type == 'show' ? 20 : 10;
      let xAxisText = [];
      let barData = [], //柱状,
        lineData = []; //折线
      let isFlag = !Array.isArray(data) && Object.keys(data).length > 0 && Object.keys(data).every(key => key.trim() !== '');
      console.log(isFlag);
      if (isFlag) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.barChart(el, data, this.baseInfo.unit, 'show');
          }, 2000)

        })
        return;
      }
      // console.log('没数据',data);
      for (var i = 0; i < data.length; i++) {
        xAxisText.push(data[i].label);
        barData.push(data[i].value);
        lineData.push(data[i].tb);
      }
      // 创建立方体正面图形
      const cubeShape1 = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0,
          width: Ewidth, // 长方体宽度
          zWidth: 2, // 阴影折角高
          zHeight: 4 // 阴影折角宽
        },
        buildPath: (ctx, shape) => {
          const api = shape.api
          const xAxisPoint = api.coord([shape.xValue, 0])
          const p0 = [shape.x, shape.y]
          const p1 = [shape.x - shape.width, shape.y]
          const p4 = [shape.x + shape.width, shape.y]
          const p2 = [
            xAxisPoint[0] - shape.width,
            xAxisPoint[1]
          ]
          const p3 = [
            xAxisPoint[0] + shape.width,
            xAxisPoint[1]
          ]

          // 绘制正面
          ctx.moveTo(p0[0], p0[1]) //0
          ctx.lineTo(p1[0], p1[1]) //1
          ctx.lineTo(p2[0], p2[1]) //2
          ctx.lineTo(p3[0], p3[1]) //3
          ctx.lineTo(p4[0], p4[1]) //4
          ctx.lineTo(p0[0], p0[1]) //0
          ctx.closePath()
        }
      })

      // 创建立方体的侧面
      const cubeShape2 = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0,
          width: Ewidth, // 长方体宽度
          zWidth: 4, // 阴影折角高
          zHeight: 1 // 阴影折角宽
        },
        buildPath: (ctx, shape) => {
          const api = shape.api
          const xAxisPoint = api.coord([shape.xValue, 0])
          const p4 = [shape.x + shape.width, shape.y]
          const p6 = [
            shape.x + shape.width + shape.zWidth,
            shape.y - shape.zHeight
          ]
          const p3 = [
            xAxisPoint[0] + shape.width,
            xAxisPoint[1]
          ]
          const p5 = [
            xAxisPoint[0] + shape.width + shape.zWidth,
            xAxisPoint[1] - shape.zHeight
          ]

          // 绘制侧面
          ctx.moveTo(p4[0], p4[1]) //4
          ctx.lineTo(p3[0], p3[1]) //3
          ctx.lineTo(p5[0] + 6, p5[1] - 6) //5
          ctx.lineTo(p6[0] + 7, p6[1] - 8) //6
          ctx.lineTo(p4[0], p4[1]) //4
          ctx.closePath()
        }
      })
      // 创建立方体的顶
      const cubeShape3 = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0,
          width: Ewidth,
          zWidth: 4,
          zHeight: 1
        },
        buildPath: (ctx, shape) => {
          const api = shape.api
          const p1 = [shape.x - shape.width, shape.y]
          const p4 = [shape.x + shape.width, shape.y]
          const p6 = [
            shape.x + shape.width + shape.zWidth,
            shape.y - shape.zHeight
          ]
          const p7 = [
            shape.x - shape.width + shape.zWidth,
            shape.y - shape.zHeight
          ]
          // 绘制顶部
          ctx.moveTo(p4[0], p4[1]) //4
          ctx.lineTo(p6[0] + 7, p6[1] - 8) //6
          ctx.lineTo(p7[0] + 7, p7[1] - 8) //7
          ctx.lineTo(p1[0], p1[1]) //1
          ctx.lineTo(p4[0], p4[1]) //4
          ctx.closePath()
        }
      })

      echarts.graphic.registerShape('cubeShape1', cubeShape1);
      echarts.graphic.registerShape('cubeShape2', cubeShape2);
      echarts.graphic.registerShape('cubeShape3', cubeShape3);
      this.$nextTick(() => {
        this.initECharts(el, xAxisText, lineData, barData, legendName, unit, type);
      })


    },
    initECharts(el, xdata, lineData, barData, legendName, unit) {
      this.mychart = echarts.init(document.getElementById(el));
      this.mychart.clear();

      // 检查数据是否全部为0
      const isBarDataAllZero = barData.every(item => item === 0 || item === null);
      const isLineDataAllZero = lineData.every(item => item === 0 || item === null);

      // 过滤数据：将数值为0的数据点设置为null
      const filteredBarData = barData.map(item => item === 0 ? null : item);
      const filteredLineData = lineData.map(item => item === 0 ? null : item);

      // 动态生成 series 数据
      const series = [];
      if (!isBarDataAllZero) {
        series.push({
          type: 'custom',
          name: legendName + (this.pageType == 2 ? '' : '(' + unit + ')'),
          color: 'rgb(96, 147, 218)',
          renderItem: (params, api) => {
            let location = api.coord([api.value(0), api.value(1)]);
            return {
              type: 'group',
              children: [
                {
                  type: 'cubeShape1',
                  shape: {
                    api,
                    xValue: api.value(0),
                    yValue: api.value(1),
                    x: location[0],
                    y: location[1]
                  },
                  style: {
                    fill: 'rgb(96, 147, 218)'
                  }
                },
                {
                  type: 'cubeShape2',
                  shape: {
                    api,
                    xValue: api.value(0),
                    yValue: api.value(1),
                    x: location[0],
                    y: location[1]
                  },
                  style: {
                    fill: 'rgb(84,128,191)'
                  }
                },
                {
                  type: 'cubeShape3',
                  shape: {
                    api,
                    xValue: api.value(0),
                    yValue: api.value(1),
                    x: location[0],
                    y: location[1]
                  },
                  style: {
                    fill: 'rgb(104, 161, 236)'
                  }
                }
              ]
            };
          },
          yAxisIndex: 0,
          data: filteredBarData,
        });
      }
      if (!isLineDataAllZero) {
        series.push({
          name: 'YOY',
          type: 'line',
          yAxisIndex: 1,
          color: '#ffaf25',
          data: filteredLineData
        });
      }

      // 动态生成图例数据
      const legendData = [];
      if (!isBarDataAllZero) {
        legendData.push(legendName + (this.pageType == 2 ? '' : '(' + unit + ')'));
      }
      if (!isLineDataAllZero) {
        legendData.push('YOY');
      }

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          appendToBody: true, // 是否将提示框放置在body元素上
          formatter: function (params) {
            let result = '';
            let name = params[0].name + "</br>";
            let dotHtml = '', dotHtml2 = '', unitd = params[0].componentSubType === "line" ? ' %' : unit;
            if (params[0]) {
              dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[0].color + '"></span> ' + params[0].seriesName + "： " + (params[0].data !== null ? params[0].data : '-') + ' ' + unitd + "</br>";
              if (params[0].seriesName == '()') {
                dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[0].color + '"></span> ' + (params[0].data !== null ? params[0].data : '-');
              }
            }
            if (params[1]) {
              dotHtml2 = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[1].color + '"></span>' + params[1].seriesName + "： " + (params[1].data !== null ? params[1].data : '-') + ' %';
            }

            result += name + dotHtml + dotHtml2;
            return result;
          },
        },
        grid: {
          top: '15%',
          right: '10%', // 增加右边距以容纳右侧 Y 轴
          left: '10%', // 增加左边距以容纳左侧 Y 轴
          bottom: '15%',
          containLabel: true
        },
        legend: {
          show: legendData.length > 0 && legendName != '', // 如果没有数据，则不显示图例
          bottom: "5%",
          data: legendData
        },
        xAxis: {
          type: 'category',
          data: xdata,
          interval: 0,
          axisLine: {
            onZero: false,
          },
          axisLabel: {
            interval: 0,
            rotate: xdata.length > 5 ? 45 : 0,
            margin: 15
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '',
            boundaryGap: false,
            axisTick: {
              show: true
            },
            axisLine: {
              show: true,
            },
            splitLine: {
              show: true, // 始终显示背景线
              lineStyle: {
                type: 'dashed' // 虚线样式
              }
            },
          },
          {
            type: 'value',
            name: ' ',
            axisTick: {
              show: true
            },
            splitLine: {
              show: false, // 始终显示背景线
              lineStyle: {
                type: 'dashed' // 虚线样式
              }
            },
            axisLine: {
              show: true,
            },
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: series
      };

      this.mychart.setOption(option);
    },
    barChart(el, data, unit, type) {
      console.log('柱状图', data);
      this.mychart = echarts.init(document.getElementById(el));
      this.mychart.clear();

      // 提取数据
      const labels = [];
      const series = [];
      const yAxisList = []; // 用于存储 Y 轴配置

      // 定义柱状图颜色数组
      const barColors = ['#5470C6', '#91CC75', '#EE6666', '#FAC858', '#73C0DE', '#3BA272', '#FC8452', '#9A60B4', '#E488C1'];
      let barColorIndex = 0; // 用于循环分配柱状图颜色

      // 定义折线图颜色数组
      const lineColors = ['#FAC858', '#73C0DE', '#3BA272', '#FC8452', '#9A60B4', '#E488C1', '#5470C6', '#91CC75', '#EE6666'];
      let lineColorIndex = 0; // 用于循环分配折线图颜色

      // 遍历 dataMap
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const dataList = data[key];

          // 提取 label（年份）
          if (labels.length === 0 && dataList && dataList.length > 0) {
            for (let i = 0; i < dataList.length; i++) {
              if (dataList[i].label) {
                labels.push(dataList[i].label);
              }
            }
          }

          // 获取当前数据的单位
          const currentUnit = (dataList && dataList[0] && dataList[0].unit) || '';

          // 根据单位决定图表类型
          const chartType = currentUnit === '%' ? 'line' : 'bar';
          // 为柱状图和折线图分配不同的颜色
          const color = chartType === 'bar' ? barColors[barColorIndex % barColors.length] : lineColors[lineColorIndex % lineColors.length];
          if (chartType === 'bar') {
            barColorIndex++; // 更新柱状图颜色索引
          } else {
            lineColorIndex++; // 更新折线图颜色索引
          }

          // 添加 series
          series.push({
            name: key + ' (' + currentUnit + ')', // 在图例中显示单位
            type: chartType,
            yAxisIndex: yAxisList.length, // 指定 Y 轴索引
            data: dataList.map(function (item) {
              return {
                value: item.data,
                unit: currentUnit // 保存单位到数据点
              };
            }),
            itemStyle: { color: color },
            lineStyle: chartType === 'line' ? {
              width: 3
            } : undefined,
            ...(chartType === 'line' ? {
              symbol: 'circle',
              symbolSize: 6
            } : {
              barMaxWidth: 30
            })
          });

          // 添加 Y 轴配置
          yAxisList.push({
            type: 'value',
            name: currentUnit, // Y 轴名称显示单位
            position: chartType === 'line' ? 'right' : 'left', // 折线图 Y 轴在右侧，柱状图 Y 轴在左侧
            axisLabel: {
              formatter: function (value) {
                return value;
              }
            },
            splitLine: {
              show: yAxisList.length === 0, // 只在第一个 Y 轴显示背景刻度线
              lineStyle: {
                type: 'dashed'
              }
            }
          });
        }
      }

      // 检查是否所有数据都是柱状图且单位相同
      const allBarsSameUnit = series.every(s => s.type === 'bar' && s.name.endsWith(`(${unit})`));

      // 如果所有数据都是柱状图且单位相同，只保留一个 Y 轴
      if (allBarsSameUnit) {
        yAxisList.length = 1; // 只保留第一个 Y 轴
        series.forEach(s => {
          s.yAxisIndex = 0; // 将所有系列的 Y 轴索引设置为 0
        });
      }

      // 分离柱状图和折线图的图例
      const barSeries = series.filter(s => s.type === 'bar');
      const lineSeries = series.filter(s => s.type === 'line');
      const legendData = barSeries.map(s => s.name).concat(lineSeries.map(s => s.name));

      // 配置项
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: function (params) {
            var result = params[0].name + '<br/>';
            for (var i = 0; i < params.length; i++) {
              var item = params[i];
              var unit = (item.data && item.data.unit) || '';
              result += item.marker + ' ' + item.seriesName.split(' (')[0] + ': ' + item.value + ' ' + unit + '<br/>';
            }
            return result;
          }
        },
        legend: {
          data: legendData, // 柱状图图例在前，折线图图例在后
          bottom: 10,
          itemGap: 20
        },
        grid: {
          top: '15%',
          right: '10%', // 增加右边距以容纳右侧 Y 轴
          left: '10%', // 增加左边距以容纳左侧 Y 轴
          bottom: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: labels,
          axisLabel: {
            interval: 0,
            rotate: labels.length > 5 ? 45 : 0,
            margin: 15
          }
        },
        yAxis: yAxisList, // 使用动态生成的 Y 轴配置
        series: series
      };

      this.mychart.setOption(option);
    },
    pieCharts(el, data, unit, type) {
      var _this = this;
      // console.log(el, data);
      let seriesData = [];
      let temGrid = { top: '20%', bottom: '10%' };
      this.mychart = echarts.init(document.getElementById(el));
      this.mychart.clear();
      for (var i = 0; i < data.length; i++) {
        data[i].name = data[i].label;
        if (data[i].label == '其他') {
          var ortherData = data[i]
          // console.log(data[i]);
        } else {
          seriesData.push(data[i]);
        }
      }
      if (typeof ortherData === 'object' && ortherData !== null && Object.keys(ortherData).length > 0) {
        seriesData.push(ortherData);
        // console.log(ortherData,seriesData,data);
      }
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b0}: {c0}' + unit
        },
        grid: type == "show" ? temGrid : {},
        title: {
          show: type == 'show' ? true : false,
          text: this.baseInfo.title,
          left: 'center',
          top: 10,
          textStyle: {
            fontSize: 20,
          }
        },
        legend: {
          right: type == 'show' ? '10%' : '0',
          top: 'center',
          orient: 'vertical', // 设置图例竖排
          type: 'scroll', //图例强制不换行（滚动）
          width: '70%',
          itemGap: type == 'show' ? 20 : 10,
          formatter: (name) => {
            // console.log(name);
            if (!name) return '';
            let tempStr = this.getEqualNewlineString(name, 10);
            for (let i = 0; i < seriesData.length; i++) {
              // console.log(seriesData[i].name, name);
              if (seriesData[i].name == name && seriesData[i].stockCode != 0) {
                return '{a|' + tempStr + '}'; // 使用{a|text}语法来表示下划线
              } else if (seriesData[i].name == name && seriesData[i].stockCode == 0) {
                return '{b|' + tempStr + '}';

              }
            }
          },
          textStyle: {
            rich: {
              a: {
                color: '#598df5',
                lineHeight: 22,
                align: 'center',
                borderWidth: 0.5,
                fontSize: type == 'show' ? 16 : 12,
                decoration: 'underline' // 设置下划线
              },
              b: {
                fontSize: type == 'show' ? 16 : 12,
              }
            }
          }
        },
        toolbox: { //可视化的工具箱
          show: false,
          itemGap: 30,
          itemSize: 20,
          right: '9%',
          feature: {
            dataView: { //数据视图
              show: false,
              title: '数据视图',
            },
            saveAsImage: {//保存图片
              show: type == 'show' ? true : false,
              title: '保存为图片'
            },
          }
        },
        series: [
          {
            name: '',
            type: 'pie',
            // radius: ['40%', '70%'],
            center: type == 'show' ? ['50%', '55%'] : ['35%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: type == 'show' ? true : false,
              position: 'outside',
              formatter: '{b}: {c} ' + unit,
              fontSize: 16
            },
            labelLine: {
              show: type == 'show' ? true : false,
            },
            labelLayout: {
              hideOverlap: false // 是否隐藏重叠标签
            },
            minAngle: 15, //最小角度
            // startAngle: 270, //起始角度
            data: seriesData,
            itemStyle: {
              normal: {
                borderColor: '#ffffff', // 发光颜色
                // borderWidth: 5,       // 发光宽度
                // shadowBlur: 10,       // 阴影模糊大小
                // shadowColor: '#f7f3ff'  // 阴影颜色
              }
            },
          }
        ],
      };
      this.mychart.setOption(option);
      // 饼图图例点击跳转到指定页面
      this.mychart.on('legendselectchanged', (param) => {

        // console.log(param)
        for (let i = 0; i < seriesData.length; i++) {
          if (param.name == seriesData[i].name && seriesData[i].stockCode != 0 && seriesData[i].table != 0) {
            _this.mychart.setOption({
              legend: { selected: { [param.name]: true } } //让图例点击后不变灰
            });
            if (seriesData[i].table != 4) {
              this.routerlinkid('/enterprises', seriesData[i].stockCode);
            } else {
              this.routerlinkid('/enterprisesF', seriesData[i].stockCode);
            }
          }
        }
      });
    },
    //params 要处理的字符串
    //length 每行显示长度
    getEqualNewlineString(params, length) {
      let text = ''
      let count = Math.ceil(params.length / length) // 向上取整数
      // 一行展示length个
      if (count > 1) {
        for (let z = 1; z <= count; z++) {
          text += params.substr((z - 1) * length, length)
          if (z < count) {
            text += '\n'
          }
        }
      } else {
        text += params.substr(0, length)
      }
      return text
    },
  }
};
</script>

<style scoped lang="scss">
.cur-pointer {
  &:hover {
    color: #4da0ff
  }
}

@import url('../../css/yuanbao/yuanbao1.css');

.miaoshu {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e0e0e0;

  th {
    border: 1px solid #e0e0e0;
    padding: 15px 12px;
    text-align: center;
    min-height: 40px;
    vertical-align: middle;
    min-width: 245px;
    max-width: 245px;
    width: 245px;
    background-color: #f3f7ff;
  }

  td {
    border: 1px solid #e0e0e0;
    padding: 8px 12px;
    text-align: left;
    min-height: 40px;
    vertical-align: middle;

    .con {
      height: 400px;
      // overflow-y: auto;
      // overflow-x: hidden;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden; //溢出内容隐藏
      text-overflow: ellipsis; //文本溢出部分用省略号表示
      display: -webkit-box; //特别显示模式
      -webkit-line-clamp: 2; //行数
      line-clamp: 2;
      -webkit-box-orient: vertical; //盒子中内容竖直排列 
      padding-bottom: 10px;
    }
  }

}

p span[style*="font-size: 10px"] {
  /* 匹配含特定样式的 span */
  display: none;
}

.background-fff {
  background-color: #fff;
}

.table-line-box {
  height: 40px;
  width: 99.9%;
  border-left: 1px solid #EBEEF5;
  border-right: 1px solid #EBEEF5;
}

.trade-detail-container {
  padding: 20px;
  font-family: sans-serif;
}

.evaluation-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #EBEEF5;

  /* Add border to the table */
}

.evaluation-table th,
.evaluation-table td {
  border: 1px solid #EBEEF5;
  padding: 8px 12px;
  text-align: center;
  min-height: 40px;
  /* Ensure cells have some height */
  vertical-align: middle;


  /* Center content vertically */
}

.evaluation-table td {
  height: 40px;
  width: 200px;
}

.evaluation-table th {
  background-color: #fff;
  font-weight: bold;
}

/* Style for the first column headers */
.evaluation-table th:first-child {
  min-width: 150px;
  /* Adjust width as needed */
  /* text-align: left; */
  background-color: #f3f7ff;
}

/* Add some extra space for the first column headers */
.evaluation-table thead th:first-child {
  padding: 12px;
}
</style>
